import { DropdownModule } from 'primeng/dropdown';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ThemeModule} from '@drl/theme/theme.module';
import {TranslateModule} from '@ngx-translate/core';

import {LoginRoutingModule} from './login-routing.module';
import {LoginComponent} from './login.component';
import {SupportBoxModule} from '../support/support.module';
import { SharedModule } from 'primeng/components/common/shared';

@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    FormsModule,
    ThemeModule.forRoot(),
    LoginRoutingModule,
    TranslateModule,
    DropdownModule,
    SupportBoxModule,
    SharedModule
  ],
  providers: [],
})
export class LoginModule {}
